import ScreenContainer from '../display/ui/ScreenContainer';
import CutscenePlayer from '../ui/CutscenePlayer';

export default class Cutscene extends Phaser.State {
  init(sceneData) {
    this.sceneData = sceneData;

    // this.game.springRollCaptionsPlugin.setData(
    //   this.game.cache.getJSON(this.sceneData.id + '_captions')
    // );
  }

  preload() {}

  create() {
    this.container = new ScreenContainer(this.game);

    if (this.game.controller.shortcutsModel.cutscenesEnabled) {
      this.cutscene = new CutscenePlayer(this.game, this.sceneData.id);
      this.container.addChild(this.cutscene);
      this.cutscene.x = this.game.defaultWidth / 2;
      this.cutscene.y = this.game.defaultHeight / 2;

      this.cutscene.onAnimComplete.addOnce(this.handleAnimComplete, this);

      this.cutscene.showSkipButton();
    } else {
      this.handleAnimComplete();
    }

    this.transition = this.game.controller.getTransition();
    this.transition.fadeOut();
  }

  handleAnimComplete() {
    this.transition.onFadeEnd.addOnce(this.handleTransitionEnd, this);
    this.transition.fadeIn();
  }

  handleTransitionEnd() {
    this.game.controller.endCutscene(this.sceneData.isEndScene);
  }

  shutdown() {
    // destroy
    this.cutscene && this.cutscene.destroy();
    this.container.destroy(true);

    // clear up
    this.cutscene = null;
    this.transition = null;
    this.container = null;
  }
}
